import React from 'react';
import { Skeleton } from '../Skeleton';

const SkeletonCartScreen = () => {
  return (
    <div className="cart-screen-skeleton">
      <div className="stepContainer">
        <Skeleton
          width="calc(33.3333333333% - 0.5em)"
          height="5px"
          backgroundType="light"
        />
        <Skeleton
          width="calc(33.3333333333% - 0.5em)"
          height="5px"
          backgroundType="light"
        />
        <Skeleton
          width="calc(33.3333333333% - 0.5em)"
          height="5px"
          backgroundType="light"
        />
      </div>
      <Skeleton
        width="100%"
        height="31.5dvh"
        backgroundType="light"
      >
        <div className="flex justify-between items-center p-4">
          <Skeleton
            width="30%"
            height="5vh"
            backgroundType="dark"
          />
          <Skeleton
            width="10%"
            height="5vh"
            backgroundType="dark"
          />
        </div>
        <div className="flex flex-col gap-4 mt-6 mb-8 px-4">
          <Skeleton
            width="100%"
            height="5dvh"
            backgroundType="dark"
          />
          <Skeleton
            width="100%"
            height="5dvh"
            backgroundType="dark"
          />
        </div>
        <div className="flex justify-between items-center px-4">
          <Skeleton
            width="100%"
            height="5dvh"
            backgroundType="dark"
          />
        </div>
      </Skeleton>

      <div className="payer_container">
        <div className="pb-2 flex flex-col gap-2 w-[90%]">
          <Skeleton
            width="90%"
            height="10px"
            backgroundType="light"
          />
          <Skeleton
            width="40%"
            height="10px"
            backgroundType="light"
          />
        </div>
        <Skeleton
          width="90%"
          height="55px"
          backgroundType="light"
        />
        <Skeleton
          width="90%"
          height="55px"
          backgroundType="light"
        />
      </div>
    </div>
  );
};

export default SkeletonCartScreen;
